import type { ReactNode } from "react";
import type { FieldError, Merge } from "react-hook-form";
import { cn } from "../lib/utils";
import { FormFieldError } from "./FormFieldError";

type FormFieldProps = {
	condensed?: boolean;
	className?: string;
	id?: string;
	children: ReactNode;
	error?: FieldError | Merge<FieldError, (FieldError | undefined)[]>;
	errorMessage?: string;
};

export const FormField = (props: FormFieldProps) => (
	<div
		id={props.id}
		className={cn(
			"relative min-h-fit flex flex-1 flex-col justify-end space-y-[12px]",
			props.condensed ? "space-y-[4px]" : undefined,
			props.className,
			props.error ? "outline outline-red-500 outline-offset-[8px] rounded-md" : undefined,
		)}
	>
		{props.children}
		<FormFieldError
			error={props.error}
			errorMessage={props.errorMessage ?? props.error?.message}
			className={cn("top-[-24px]")}
		/>
	</div>
);
